import React from "react";
import {
  Box,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
  Button,
} from "@mui/material";
import img from "./img/webviweImg.png";
import icon1 from "./img/icon1.svg";
import icon2 from "./img/icon2.svg";
import icon3 from "./img/icon3.svg";
import KeyboardDoubleArrowRightSharpIcon from "@mui/icons-material/KeyboardDoubleArrowRightSharp";
import SentimentSatisfiedAltSharpIcon from "@mui/icons-material/SentimentSatisfiedAltSharp";
import ThumbUpSharpIcon from "@mui/icons-material/ThumbUpSharp";
import TrendingUpSharpIcon from "@mui/icons-material/TrendingUpSharp";

const TextSection1 = () => {
  return (
    <Box
      sx={{
        py: { xs: 6, sm: 8, md: 12 }, // padding vertical: mobile to desktop
        backgroundImage: `url('bg3.svg')`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "2rem", md: "3rem" },
            lineHeight: 1.2,
            color: "rgb(255,255,255)",
            mb: 3,
          }}
        >
          Unlock the Power of Web, Within{" "}
          <span style={{ color: "#00D084" }}>WhatsApp</span>
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
            color: "rgb(255,255,255,0.7)",
            mb: 2,
          }}
        >
          With WhatsApp Webviews, businesses can now load their websites or
          landing pages directly within WhatsApp chats.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
            color: "rgb(255,255,255,0.7)",
            mb: 4,
          }}
        >
          So, no more lost customers. Just seamless sales, support &
          engagement—all inside WhatsApp
        </Typography>

        <Grid container spacing={6} alignItems="center">
          {/* Left Section: Text Content */}
          <Grid
            item
            xs={12}
            md={7}
            sx={{
              px: { xs: 2, sm: 4, md: 6 }, // padding horizontal responsive
              order: { xs: 2, md: 1 },
            }}
          >
            {/* List Items */}
            <List
              sx={{ display: "flex", flexDirection: "column", gap: 4 }}
              disablePadding
            >
              {[
                {
                  icon: (
                    <SentimentSatisfiedAltSharpIcon sx={{ fontSize: 32 }} />
                  ),
                  title: "Open Web within WhatsApp",
                  desc: "Give your users something new & exciting with Webviews",
                  grayscale: true,
                },
                {
                  icon: <ThumbUpSharpIcon sx={{ fontSize: 32 }} />,
                  title: "Enhanced Engagement",
                  desc: "Simplify complex processes, like booking buses with hundreds of stops, directly within the chat, along with a ton of other unique use cases.",
                  grayscale: true,
                },
                {
                  icon: <TrendingUpSharpIcon sx={{ fontSize: 32 }} />,
                  title: "Increased Conversion Rates",
                  desc: "Increased Conversion Rates mean more visitors taking desired actions like buying, signing up, or contacting you.",
                  grayscale: false,
                },
              ].map(({ icon, title, desc, grayscale }, idx) => (
                <Box
                  sx={{
                    backgroundColor: "rgb(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                    p: 4,
                    borderRadius: "10px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: { xs: "left", md: "center" },
                      flexDirection: { xs: "column", md: "row" },
                      gap: 1,
                      color: "#00d084",
                    }}
                  >
                    {icon}
                    <Typography
                      sx={{
                        fontSize: "1.5rem",
                        fontWeight: 600,
                      }}
                    >
                      {title}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      textAlign: "left",
                      fontSize: "1.2rem",
                      color: "rgb(255, 255, 255, 0.7)",
                      mt: 1,
                    }}
                  >
                    {desc}
                  </Typography>
                </Box>
              ))}
            </List>

            {/* Button */}
            <Box mt={3} sx={{ textAlign: { xs: "center", md: "left" } }}>
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#00D084",
                  color: "#fff",
                  fontWeight: "bold",
                  px: 4,
                  py: 1.5,
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  "&:hover": { bgcolor: "#00b96e" },
                  width: { xs: "100%", sm: "auto" },
                  maxWidth: 300,
                  marginLeft: { xs: 0, lg: "42px" },
                }}
              >
                Talk to Sales
              </Button>
            </Box>
          </Grid>

          {/* Right Section: Image */}
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              px: { xs: 2, md: 0 },
              order: { xs: 1, md: 2 },
            }}
          >
            <Box
              component="img"
              src={img}
              alt="WhatsApp Webview"
              sx={{
                width: { xs: "100%", sm: "90%", md: "100%" },
                maxWidth: { xs: "100%", sm: 450, md: 550 },
                height: "auto",
                objectFit: "contain",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default TextSection1;
